import branding from '../../config/branding';

interface Theme {
  primary: string;
  text: string;
}

export const Pink: Theme = {
  primary: branding.colors.primary,
  text: '#fff',
};

export const Blue: Theme = {
  primary: (branding.colors as Record<string, string>).secondary || branding.colors.primary,
  text: '#fff',
};
